<template>
  <v-content>
    <v-container class="fill-height py-0 my-0" fluid>
      <v-row align="center" justify="center" class="py-0 my-0">
        <v-col
          cols="12"
          sm="6"
          md="5"
          class="py-0 my-0 d-flex"
          style="background: #f5f5f5; height: 100vh; padding: 0"
        >
          <div
            class="mx-auto my-auto d-flex flex-column"
            style=" width: 100%; height: 100%; position: relative"
          >
            <img
              src="@/assets/logo-flextd.svg"
              alt="logo"
              width="250px"
              class="mx-auto"
              style="position: absolute; transform: translateX(-50%); left: 50%; top: 20%"
            />
            <img
              src="@/assets/fondo-flextd-login.webp"
              alt="centro"
              style="object-fit: cover; height: 100%;width: 100%"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="7" class="d-flex justify-center">
          <v-card
            flat
            class="px-0 py-0 card-form animate__animated animate__backInDown"
            style="
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
                border-radius: 20px !important;
                padding-top: 40px !important;
                overflow: auto;
                max-height: 90vh 
              "
          >
            <ValidationObserver ref="obs" v-slot="{ passes }">
              <v-row class="my-0 mx-0">
                <v-col cols="12" class="mt-n5 pb-0">
                  <label for="país">País</label>
                  <ValidationProvider
                    name="país"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      filled
                      :items="stores"
                      item-text="name"
                      item-value="id"
                      v-model="store"
                      dense
                      type="text"
                      :error-messages="errors"
                      return-object
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="código postal">Empresa</label>
                  <ValidationProvider
                    name="empresa"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="company_name"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="Nombre de la empresa"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="docNumber">{{ docTypes[store.id].name }}</label>
                  <ValidationProvider
                    :name="docTypes[store.id].name"
                    :rules="{
                      required: true,
                      ...docTypes[store.id].validation,
                    }"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="docNumber"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="123456789"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label
                    for="provincia"
                    style="display: inline-block;margin-bottom: 8px"
                    >Provincia</label
                  >
                  <ValidationProvider
                    name="provincia"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      :disabled="!store.id"
                      :items="dataState"
                      :loading="loadingProvincia"
                      item-text="name"
                      item-value="id"
                      v-model="stateId"
                      placeholder="Provincia"
                      class="rounded-small"
                      dense
                      filled
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="código postal">Código postal</label>
                  <ValidationProvider
                    name="código postal"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="zipCode"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="123456"
                      :error-messages="errors"
                      maxlength="8"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <label for="dirección">Dirección</label>
                  <ValidationProvider
                    name="dirección"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="location"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="Dirección"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                  <label for="dirección">Sitio web</label>
                  <ValidationProvider
                    name="sitio web"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="website"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="sitio web"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="nombre">Nombre</label>
                  <ValidationProvider
                    name="nombre"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="name"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="Nombre"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="apellido">Apellido</label>
                  <ValidationProvider
                    name="apellido"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="lastName"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="Apellido"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="email">Correo</label>
                  <ValidationProvider
                    name="email"
                    rules="email|required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="email"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="ejemplo@mail.com"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="email">Teléfono</label>
                  <ValidationProvider
                    name="phone"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="phone"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="ejemplo@mail.com"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="contraseña">Contraseña</label>
                  <ValidationProvider
                    name="contraseña"
                    rules="required|min:6"
                    vid="confirmation"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      type="password"
                      autocomplete="off"
                      v-model="password"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="Ingresa tu contraseña"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <label for="verificar contraseña">Verificar contraseña</label>
                  <ValidationProvider
                    name="verificar contraseña"
                    rules="required|confirmed:confirmation"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      type="password"
                      autocomplete="off"
                      v-model="verifyPassword"
                      class="mt-2"
                      color="accent"
                      dense
                      filled
                      placeholder="Confirma tu contraseña"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="12" style="padding-top: 0;">
                  <v-btn
                    :loading="loading"
                    @click="passes(signUp)"
                    rounded
                    elevation="0"
                    large
                    block
                    dark
                    color="primary"
                  >
                    Registrate
                  </v-btn>
                  <span
                    @click="HandlerRouter('login')"
                    style="cursor: pointer"
                    class="d-flex justify-center mt-2 primary--text"
                    >Ya tienes cuenta? Inicia sesion
                  </span>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
export default {
  props: {
    source: String,
  },

  data() {
    return {
      email: "",
      password: "",
      name: "",
      lastName: "",
      verifyPassword: "",
      zipCode: "",
      docType: "CUIT",
      docNumber: "",
      stateId: "",
      location: "",
      company_name: "",
      website: "",
      phone: "",
      store: { id: 6, name: "Chile", countryId: 2 },
      stores: [
        { id: 6, name: "Chile", countryId: 2 },
        { id: 5, name: "Argentina", countryId: 1 },
        { id: 10, name: "Mexico", countryId: 3 },
      ],
      docTypes: {
        6: { name: "RUT", validation: { rutValidation: true } },
        5: {
          name: "CUIT",
          validation: {
            cuitValidation: true,
          },
        },
        10: {
          name: "RFC",
          validation: { regex: /^[A-Za-z]{3,4}[0-9]{6}[0-9A-Za-z]{3}$/ },
        },
      },
      dataState: [],
      showPassword: false,
      loading: false,
      loadingProvincia: false,
    };
  },

  created() {
    this.HandlerProvincia();
  },

  watch: {
    store() {
      this.stateId = "";
      this.docNumber = "";
      this.HandlerProvincia();
    },
  },

  methods: {
    HandlerRouter(router) {
      this.$router.push({ name: router });
    },

    async HandlerProvincia() {
      try {
        this.loadingProvincia = true;
        const store_id = this.store.countryId;
        const request = { country_id: store_id };

        const response = await this.$store.dispatch("auth/GET_STATES", request);
        this.dataState = response.data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingProvincia = false;
      }
    },

    async signUp() {
      this.loading = true;
      try {
        const request = {
          email: this.email,
          password: this.password,
          store_id: this.store.id,
          country_id: this.store.countryId,
          billing_zip_code: this.zipCode,
          first_name: this.name,
          last_name: this.lastName,
          doc_number: this.docNumber,
          doc_type: this.docTypes[this.store.id].name,
          state_id: this.stateId,
          location: this.location,
          company_name: this.company_name,
          contact_phone: this.phone,
          website_url: this.website,
        };
        await this.$store.dispatch("auth/SIGNUP", request);
        this.$snotify.success("Usuario registrado exitosamente", "Exito!");
        this.$router.push({ name: "login" });
      } catch (error) {
        console.log(error);
        if (error.response) {
          if (error.response?.data?.error?.err_message) {
            this.$snotify.error(error.response.data.error.err_message, "Error");
          } else {
            this.$snotify.error(
              "Error al registrar, porfavor intentelo nuevamente",
              "Error"
            );
          }
        } else {
          this.$snotify.error("El servidor no responde. Error 500", "¡Vaya!");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.card-form {
  width: 84%;
  max-width: 760px;
}
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: rgba(109, 96, 218, 0.4);
}
</style>
